export const getInitialState = () => ({
  userPreferences: undefined,
  error: undefined,
  showBanner: undefined,
});
